import { Component } from "@angular/core";

@Component({
  selector: "app-print-cards",
  templateUrl: "./print-cards.component.html",
  styleUrls: ["./print-cards.component.scss"],
  standalone: false,
})
export class PrintCardsComponent {}
